import React, { Component } from 'react';
import { Link } from 'react-router';
import { languages, selectLanguage } from '../services/lang';
import { beep } from '../services/audio';
import './language.css';
import { trackView } from '../services/analytics';

export default class Language extends Component {
  
  componentDidMount() {
    beep();
    trackView("Select Language");
  }
  
  select = language => {
    selectLanguage(language);
  }
  
  renderLanguageButtons() {
    return languages.map(language => 
      <Link 
        to="/menu"
        key={language.code} 
        className="language-button"
        onClick={() => this.select(language)}>
        {language.title}
      </Link>
    );
  }
  
  render() {
    return (
      <div className="language">
        <h1>Select your language</h1>
        <div className="language-button-wrapper">
          {this.renderLanguageButtons()}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Language.js